<template>
	<div id="app">
		<el-container>
			<el-header>
				<div v-if='$route.name != "error" && $route.name != "login"'>
					<!-- 头部 -->
					<v-header ref="vheader"></v-header>
				</div>
			</el-header>
			<el-main>
				<!-- 设置keepAlive为true的页面，页面被缓存，返回时不刷新 -->
				<keep-alive>
					<router-view v-if='$route.meta.keepAlive'></router-view>
				</keep-alive>
				<router-view v-if='!$route.meta.keepAlive && isRouterAlive'></router-view>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import vHeader from './components/common/Header.vue';
	import {
		getAllParam,
		getParam
	} from './utils/api-utils/api-params.js';
	import {
		getCustomerInfo
	} from './utils/api-utils/api-customer.js';
	import {
		getSubMallInfoList,
		getProductOrderInfo
	} from './utils/api-utils/api-auth.js';
	import { system } from './utils/api-utils/api-sys.js';
	export default {
		name: 'app',
		components: {
			'v-header': vHeader
		},
		provide() { // 父组件中返回要传给下级的数据
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		async created() {
			// 正式版访问需要检测当前版本
			if (location.href.includes("/jmc/pcmall")) {
				// 获取吉商城接口当前版本（用作灰度切换）
				let JmallApiVersion = await this.getJmallApiVersion();
				console.log("当前版本：" + JmallApiVersion);
				if (JmallApiVersion == "jmall-single") {
					let memberEncryptStr = localStorage.getItem("memberEncryptStr");
					// 生成新地址，跳转到single服务
					let newHref = location.href.replace('/jmc/', '/jmall_pc_single/');
					// 测试代码
					console.log("跳转到signle：" + newHref);
					location.replace(newHref);
					return;
				}
			}

			// 加载系统参数（含缓存清空，添加其他缓存需要在这步之后）
			await this.getSysParams();

			// 校验customerInfo信息
			this.checkCustomer();

			// 检测用户产品订购信息
			this._checkProductOrder();

			// 保存用户自定义域名
			let params = this._getUrlParams();
			// 来源域名存在则需要保存到缓存
			localStorage.setItem("userRef", params.ref || "");
		},
		mounted() {
			// 监听BroadcastChannel消息 判断吉客号是否变更
			const channel = new BroadcastChannel("jmall-memberName");
			channel.addEventListener("message", (event) => {
				let curCustomerId = system.getCustomerId();

				let isNotLogin = curCustomerId === undefined;
				let isDifLoginer = curCustomerId !== event.data;
				let isCurLogout = curCustomerId === '' && event.data === '';

				!isCurLogout && (isNotLogin || isDifLoginer) && window.location.replace('#/login');
			});

			// 清理旧监听器（安全起见）
			window.removeEventListener('message', this.handleWechatMessage);
			// 监听微信扫码回调
			window.addEventListener('message', this.handleWechatMessage);
		},
		methods: {
			handleWechatMessage(e) {
				// 安全：验证 origin（推荐）
				if (e.origin !== 'https://jmall.jackyun.com') return;

				if (e.data && e.data.type === 'WECHAT_LOGIN_SUCCESS') {
					const { code, state } = e.data;

					this.$eventBus.$emit("setWxLoginCode", code);
				}
			},

			reload() {
				// header 变化之后更新数据
				this.isRouterAlive = false;
				this.$nextTick(function() {
					this.isRouterAlive = true
				})
			},

			/**
			 * 获取吉商城接口当前版本（用作灰度切换）
			 */
			getJmallApiVersion() {
				return new Promise((resolve, reject) => {
					this.$request.jackyunPost({
						method: "sys.getsetting",
						content: "jmall_api_version,pcmall_version"
					}, (res) => {
						let data = ""
						if (res.code == 200) {
							data = res.data.jmall_api_version;
						}

						// 缓存当前版本信息
						localStorage.setItem("pcmall_version", res.data.pcmall_version);

						resolve(data || "jmall");
					})
				});
			},

			/**
			 * 获取系统配置参数，渠道仓库等
			 */
			async getSysParams() {
				let _this = this;

				// 清除配置缓存
				localStorage.removeItem('userSetting');

				// 首次进入刷新全库缓存参数
				await getAllParam(true);
				let paramList = await getParam("bindSaleChannelId,bindSaleChannelName,bindWarehouseId,defaultMemberGradeId,defaultMemberGradeName,commission_mode,pc_goodsDetailStyle,currencySymbol,pcmall_version,decimalKeepPlaces");
				if (paramList.bindSaleChannelId) {
					// 保存到缓存
					localStorage.setItem("pc_channelId", paramList.bindSaleChannelId);
					// 获取到店铺Id后，获取购物车总数
					this.$eventBus.$emit("updateHeaderShopCartCount");
				}

				// 绑定的吉客云渠道名称
				if (paramList.bindSaleChannelName) {
					// 保存到缓存
					localStorage.setItem("pc_channelName", paramList.bindSaleChannelName);
				}

				// 默认仓库ID
				if (paramList.bindWarehouseId) {
					// 保存到缓存
					localStorage.setItem("pc_warehouseId", paramList.bindWarehouseId);
				}

				// 默认会员等级ID
				if (paramList.defaultMemberGradeId) {
					// 保存到缓存
					localStorage.setItem("pc_defaultMemberGradeId", paramList.defaultMemberGradeId);
				}

				// 默认会员等级名称
				if (paramList.defaultMemberGradeName) {
					// 保存到缓存
					localStorage.setItem("pc_defaultMemberGradeName", paramList.defaultMemberGradeName);
				}

				// 分销模式
				localStorage.setItem('pc_commissionMode', paramList.commission_mode ? paramList
					.commission_mode : '');

				// 商品详情样式
				localStorage.setItem('pc_goodsDetailStyle', paramList.pc_goodsDetailStyle ? paramList
					.pc_goodsDetailStyle : 0);

				// 小数保留位数
				localStorage.setItem('decimalKeepPlaces', paramList.decimalKeepPlaces || 2);

				// 币种符号
				// this.$currency.setSymbol(paramList.currencySymbol || "￥");
				setTimeout(function() {
					let symbol = paramList.currencySymbol || "￥";
					_this.$currency.setSymbol(symbol);
				}, 5000);
			},

			// 校验customerInfo信息
			async checkCustomer() {
				// 获取缓存中信息
				if (!localStorage.getItem("pc_customerId")) {
					return;
				}

				// 用当前customerId查不到客户信息时退出登录
				let jmallCus = await getCustomerInfo({}, true);
				if (jmallCus.customerId) {
					return;
				}
				this.$refs.vheader.logout();
			},

			/**
			 * 检测用户产品订购信息
			 */
			async _checkProductOrder(checkId) {
				// 标识Id检测，防止线程重复执行（存在id需要检测，检测不通过则不执行，不存在则重新生成，说明是最新的调用）
				if (checkId) {
					let currCheckId = localStorage.getItem("productOrderCheckId");
					if (currCheckId != checkId) {
						return;
					}
				} else {
					// 生成标识Id
					checkId = new Date().getTime();
					localStorage.setItem("productOrderCheckId", checkId);
				}

				try {
					// 获取订购信息
					let productOrderInfo = await getProductOrderInfo();
					localStorage.setItem("productOrderInfo", JSON.stringify(productOrderInfo));
					if (!productOrderInfo.productCode) {
						throw new Error("未获取到产品订购信息");
					}
					if (productOrderInfo.isExpired) {
						throw new Error("产品订购已到期");
					}

					// 获取吉客号和子账号信息
					let memberName = localStorage.getItem("JackyunUserName");
					// 子商城名称 accountname
					let subMemberName = localStorage.getItem("SubMemberName");

					// 获取当前吉客号的子商信息
					let subMallInfoList = await getSubMallInfoList();
					// 当前小程序的商城信息
					let currMallInfo = subMallInfoList.find(t => t.accountName == (subMemberName || memberName));
					if (!currMallInfo) {
						throw new Error("未获取到当前商城注册信息");
					}
					if (currMallInfo.status == 0) {
						throw new Error("当前商城未开启");
					}

					// 清空异常信息
					localStorage.setItem("productOrderErrMsg", '');

					// 缓存子商城名称 shopname
					localStorage.setItem("SubJmallName", currMallInfo.subJmallName);
				} catch (e) {
					localStorage.setItem("productOrderErrMsg", e.message);
					// 产品要求统一提示“升级中”
					this.$message.error({
						message: "商城升级中，请联系商家处理"
					});
					console.log(e.message);
				} finally {
					// 每隔10分钟检测一次
					setTimeout(() => {
						this._checkProductOrder(checkId);
					}, 10 * 60 * 1000);
				}
			},

			/**
			 * 获取地址栏传参
			 */
			_getUrlParams() {
				try {
					let hash = window.location.hash;
					let queryIndex = hash.indexOf('?');

					// 如果没有参数，返回空对象
					if (queryIndex === -1) {
						return {};
					}

					let queryString = hash.slice(queryIndex + 1); // 提取 "ref=www.haoshun365.com&id=123"
					let params = new URLSearchParams(queryString);

					let result = {};
					params.forEach((val, key) => {
						result[key] = val || "";
					});

					return result;
				} catch (e) {
					return {};
				}
			},
		}
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.el-header {
		width: 100%;
		height: 50px !important;
		padding: 0 !important;
	}

	.el-main {
		padding: 0 !important;
		position: relative;
	}

	.el-message-box__message p {
		word-break: break-all;
	}

	.el-message {
		min-width: unset !important;
		width: fit-content !important;
		padding: 15px 20px !important;
	}

	*::-webkit-scrollbar {
		width: 9px;
		height: 9px;
	}

	*::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background: #c1c1c1;
	}

	*::-webkit-scrollbar-track {
		border-radius: 10px;
		background: #f1f1f1;
	}

	.min-scroll::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 5px !important;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 5px !important;
	}

	.min-scroll::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 10px !important;
		background: #c1c1c1 !important;
	}

	.min-scroll::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		border-radius: 10px !important;
		background: #f1f1f1 !important;
	}

	.el-message-box__title {
		font-size: 16px !important;
		text-align: center !important;
	}

	.text-ellipsis_oneline {
		white-space: nowrap;
		overflow: hidden;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	/* 全面隐藏浏览器自带的密码 eye 和清除按钮 */
	input[type="password"] {
		/* 针对 IE / Edge */
		-webkit-text-security: disc;
		/* 确保仍是密码点 */
	}
	
	/* 隐藏 Edge/IE 的 eye 图标 */
	input[type="password"]::-ms-reveal,
	input[type="password"]::-ms-clear {
		display: none !important;
	}
</style>